import themed from '@/ui/Theme/themed'

// These components requires theme, so we are exporting enhanced elements
// User can still use vanilla elemnts by importing them directly from respective file
import AvatarField from './AvatarField'
import TypeField from './TypeField'

const themedAvatarField = themed(AvatarField)
const themedTypeField = themed(TypeField)

export { themedAvatarField as AvatarField }
export { themedTypeField as TypeField }

// These components doesn't require theming, they are exported directly
export ButtonField from './ButtonField'
export BooleanField from './BooleanField'
export CombinedField from './CombinedField'
export DateField from './DateField'
export FieldTitle from './FieldTitle'
export ImageField from './ImageField'
export TextField from './TextField'
export TextInput from './TextInput'
export IndexField from './IndexField'



// WEBPACK FOOTER //
// ./ui/Data/index.js